import { useEffect, useState } from "react";
import { Stepper, Step, StepLabel, Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useQuery } from "@apollo/client";
import { GET_MEMBER_DETAILS } from "../graphql/queries";
const steps = ["Registration", "Complete Profile", "Payment", "Issue MemberID Card"];

const CustomStepIcon = ({ completed }) => {
    return completed ? (
        <CheckCircleIcon sx={{ color: "green" }} />
    ) : (
        <CheckCircleIcon sx={{ color: "gray" }} />
    );
};

const MembershipStepper = () => {
    const [mobile, setMobile] = useState("");
    useEffect(() => {
        const storedMobile = localStorage.getItem("mobile");
        if (storedMobile) {
            setMobile(storedMobile);
        }
    }, []);

    const { loading, error, data } = useQuery(GET_MEMBER_DETAILS, {
        variables: { mobile },
        skip: !mobile, // Skip query if mobile is not set
    });
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;
    if (!data?.member) return <p>No data found</p>;

    const member = data.member;

    // Mandatory profile fields
    const requiredFields = [
        "ID_Proof_Type", "ID_Proof_Number", "Pan_Card", "Pan_Number",
        "Email", "Occupation", "Address", "Family_Details", "Marital_Status"
    ];

    const isProfileCompleted = requiredFields.every(field => {
        const value = member?.[field];
        return value !== undefined && String(value).trim() !== "";
    });

    const isPaymentCompleted = member?.Payment_Status?.toLowerCase() === "paid";
    const isIDCardGenerated = member?.ID_Card?.toLowerCase() === "generated";

    // Determine step completion independently
    const stepsCompleted = [
        true,
        isProfileCompleted,
        isPaymentCompleted,
        isProfileCompleted && isPaymentCompleted && isIDCardGenerated
    ];


    console.log("Profile Completed:", isProfileCompleted);
    console.log("Payment Completed:", isPaymentCompleted);
    console.log("ID Card Generated:", isIDCardGenerated);
    console.log("Steps Completed:", stepsCompleted);




    return (
        <Box sx={{ width: "100%", my: 3 }}>
            {error && <Typography color="error" sx={{ textAlign: "center" }}>{error}</Typography>}

            <Stepper activeStep={stepsCompleted.lastIndexOf(true)} alternativeLabel>
                {steps.map((label, index) => (
                    <Step key={label} completed={stepsCompleted[index]}>
                        <StepLabel StepIconComponent={(props) => <CustomStepIcon completed={stepsCompleted[index]} {...props} />}>
                            {label}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
};

export default MembershipStepper;
